import { Link } from 'react-router-dom';
import { bannerComics } from '@/mocks/comics';
import { useState, useEffect, useCallback } from 'react';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const banners = bannerComics;

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % banners.length);
  }, [banners.length]);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const currentBanner = banners[currentSlide];

  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${currentBanner.coverImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 h-full max-w-[1280px] mx-auto px-4 md:px-6 flex flex-col justify-center">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-4">
            <span className="px-3 py-1 bg-accent-500/90 text-background-50 text-xs rounded-full font-medium">
              {currentBanner.category}
            </span>
            <span className="px-3 py-1 bg-background-50/20 text-background-50 text-xs rounded-full backdrop-blur-sm">
              {currentBanner.status}
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 font-heading leading-tight">
            {currentBanner.title}
          </h1>

          <p className="text-sm md:text-base text-background-50/80 mb-6 line-clamp-2 max-w-lg leading-relaxed">
            {currentBanner.description}
          </p>

          <div className="flex items-center gap-3 mb-8">
            <div className="flex items-center gap-1 text-accent-400">
              <i className="ri-star-fill"></i>
              <span className="text-background-50 font-semibold">{currentBanner.rating}</span>
            </div>
            <span className="text-background-50/60 text-sm">
              <i className="ri-eye-line mr-1"></i>
              {(currentBanner.views / 10000).toFixed(1)}万阅读
            </span>
            <span className="text-background-50/60 text-sm">
              <i className="ri-heart-line mr-1"></i>
              {(currentBanner.favorites / 10000).toFixed(1)}万收藏
            </span>
          </div>

          <div className="flex items-center gap-4">
            <Link
              to={`/comic/${currentBanner.id}`}
              className="btn-primary text-sm px-8 py-3"
            >
              <i className="ri-book-open-line mr-2"></i>
              立即阅读
            </Link>
            <Link
              to="/category/fantasy"
              className="btn-outline text-sm px-8 py-3 border-background-50/40 text-background-50 hover:border-background-50 hover:text-background-50"
            >
              探索更多
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide
                  ? 'bg-accent-500 w-6'
                  : 'bg-background-50/40 hover:bg-background-50/60'
              }`}
              aria-label={`切换到第${index + 1}张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}